import React from "react";
import moment, { isMoment } from "moment";
import { SingleDatePicker } from "react-dates";
import { Field } from "redux-form";
import "./SingleDatePickerWrapper.css";
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";

class SingleDatePickerWrapper extends React.Component {
  state = {
    focused: null,
  };

  handleChangeDate = (date) => {
    if (isMoment(date)) {
      this.props.input.onChange(date.format("YYYY-MM-DD"));
    } else {
      this.props.input.onChange("");
    }
  };

  isOutsideRange = (day) => {
    const { filterValues, source, input } = this.props;

    const gte = filterValues[`${source}_gte`];
    const lte = filterValues[`${source}_lte`];

    switch (input.name) {
      case input.name.includes("lte") && input.name:
        return gte
          ? moment(gte).isSameOrAfter(day, "day") || moment().isBefore(day)
          : moment().isBefore(day);
      case input.name.includes("gte") && input.name:
        return moment(day).isAfter(lte);
      default:
        return moment().isBefore(day);
    }
  };

  render() {
    const { value } = this.props.input;
    let date = null;
    if (value && value !== "") {
      date = moment(value);
    }
    return (
      <SingleDatePicker
        id={this.props.input.name}
        date={date}
        focused={this.state.focused}
        onDateChange={this.handleChangeDate}
        onFocusChange={({ focused }) => this.setState({ focused })}
        displayFormat="DD-MM-YYYY"
        isOutsideRange={this.isOutsideRange}
        numberOfMonths={1}
        placeholder={this.props.label}
        showClearDate
        noBorder
      />
    );
  }
}

const RangeDatePicker = (props) => (
  <span>
    <Field
      name={`${props.source}_gte`}
      component={SingleDatePickerWrapper}
      label="From date"
      source={props.source}
      filterValues={props.filterValues}
    />
    <Field
      name={`${props.source}_lte`}
      component={SingleDatePickerWrapper}
      label="To date"
      source={props.source}
      filterValues={props.filterValues}
    />
  </span>
);

export default RangeDatePicker;



// WEBPACK FOOTER //
// ./src/components/inputs/RangeDatePicker/RangeDatePicker.js